import _ from 'lodash'
import { connect } from 'react-redux'
import { Flex, Box } from 'rebass'
import { Input } from 'reactstrap'
import styled from 'styled-components'
import Button from '../Button'
import SubHeading from '../Heading/SubHeading'
import { getIcon } from '../Icon'
import { prepareEkycDetailResult } from 'e-submission/utils'
import React from 'react'
import FaceComparisonResult from './FaceComparisonResult'
import { getCurrentApp } from 'e-submission/apps/selectors'

const FlexModified = styled(Flex)`
  flex-wrap: nowrap;

  @media (max-width: 535px) {
    flex-wrap: wrap;
  }
`
const Container = styled.div`
  display: flex;
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: relative;

  &::before {
    content: '';
    display: block;
    border-top: solid 1px ${({ theme }) => theme.variables['$color-silver']};
    position: absolute;
    top: 1px;
    left: 1rem;
    right: 1rem;
  }

  @media (max-width: 535px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`
const Footer = styled.div`
  display: flex;
  justify-content: center;
`
const DetailContainer = styled.div`
  width: 100%;
  padding-left: 1.5rem;

  @media (max-width: 535px) {
    padding-left: 0;
  }
`

const SubHeadingModified = styled(SubHeading)`
  color: ${({ theme }) => theme.variables['$brand-primary']};
`
export const DetailBackCitizenId = ({ detail, laserCode }) => (
  <Container>
    <div>{getIcon('citizenIdBack')}</div>
    <DetailContainer>
      <SubHeadingModified>หมายเลขหลังบัตรประชาชน</SubHeadingModified>
      <Flex width={[1, 1 / 2]} pr={[0, 1]}>
        <Input value={laserCode} disabled style={{ border: '0', letterSpacing: '2px' }} />
      </Flex>
    </DetailContainer>
  </Container>
)
export const DetailFrontCitizenId = ({ detail, frontIdCardImage }) => (
  <Container>
    <div style={{ paddingBottom: '14px' }}>
      {detail?.frontIdCardResult?.idCardImageUrl ? (
        <img src={frontIdCardImage} width="276" height="161" />
      ) : (
        getIcon('citizenIdFront')
      )}
    </div>
    <DetailContainer>
      <SubHeadingModified>ข้อมูลบัตรประชาชน</SubHeadingModified>
      <FlexModified mt={1}>
        <Box mr={[0, 1]} width={1}>
          คำนำหน้า <Input value={detail.frontIdCardResult.titleTh} disabled />
        </Box>
        <Box width={1}></Box>
      </FlexModified>
      <FlexModified mt={1}>
        <Box mr={[0, 1]} width={1}>
          ชื่อ <Input value={detail.frontIdCardResult.firstNameTh} disabled />
        </Box>
        <Box mt={[1, 0]} width={1}>
          นามสกุล <Input value={detail.frontIdCardResult.lastNameTh} disabled />
        </Box>
      </FlexModified>
      <FlexModified mt={1}>
        <Box mr={[0, 1]} width={1}>
          หมายเลขบัตรประชาชน <Input value={detail.frontIdCardResult.citizenId} disabled />
        </Box>
        <Box mt={[1, 0]} width={1}>
          เกิดวันที่ <Input value={detail.frontIdCardResult.dateOfBirth} disabled />
        </Box>
      </FlexModified>
      <FlexModified column mt={1}>
        ที่อยู่ <Input value={detail.frontIdCardResult.address} disabled />
      </FlexModified>
    </DetailContainer>
  </Container>
)

export const DetailPassport = ({ detail, frontPassportImage }) => (
  <Container>
    <div style={{ paddingBottom: '14px' }}>
      {detail?.passportResult?.idCardImageUrl ? (
        <img src={frontPassportImage} width="276" height="161" />
      ) : (
        getIcon('rmsPassportNull')
      )}
    </div>
    <DetailContainer>
      <SubHeadingModified>ข้อมูลหนังสือเดินทาง</SubHeadingModified>
      <FlexModified mt={1}>
        <Box mr={[0, 1]} width={1}>
          เลขที่หนังสือเดินทาง <Input value={detail.passportResult.passportNumber} disabled />
        </Box>
        <Box width={1}></Box>
      </FlexModified>
      <FlexModified mt={1}>
        <Box mr={[0, 1]} width={1}>
          ชื่อ <Input value={detail.passportResult.firstName} disabled />
        </Box>
        <Box mt={[1, 0]} width={1}>
          ชื่อกลาง <Input value={detail.passportResult.middleName} disabled />
        </Box>
      </FlexModified>
      <FlexModified mt={1}>
        <Box mr={[0, 1]} width={1}>
          นามสกุล <Input value={detail.passportResult.lastName} disabled />
        </Box>
        <Box mt={[1, 0]} width={1}>
          เพศ <Input value={detail.passportResult.gender} disabled />
        </Box>
      </FlexModified>
      <FlexModified column mt={1}>
        จังหวัดที่ออก <Input value={detail.passportResult.issuingState} disabled />
      </FlexModified>
      <FlexModified column mt={1}>
        สัญชาติ <Input value={detail.passportResult.nationality} disabled />
      </FlexModified>
      <FlexModified column mt={1}>
        วันเดือนปีที่เกิด <Input value={detail.passportResult.dateOfBirth} disabled />
      </FlexModified>
      <FlexModified column mt={1}>
        วันหมดอายุ <Input value={detail.passportResult.dateOfExpiry} disabled />
      </FlexModified>
    </DetailContainer>
  </Container>
)

const ImageContainer = styled.div`
  margin: 0 auto;
  padding: 1.5rem;
  text-align: center;
`

const ResultContainer = styled.div`
  margin: 0 auto;
  text-align: center;
`

const ResultContainerAlignLeft = styled.div`
  margin: 0 auto;
  text-align: left;
`

const SimilarityContainer = styled.div`
  margin: 0.5rem auto;
  text-align: center;
  background-color: #f5f5f5;
  width: 45%;
  color: #3ac83a;
  border-radius: 0.5rem;
  height: 2.75rem;
`

export const ResultFR = ({ detail, imageLeft, imageRight, hasFaceRecognitionImageFile, hasFaceImageFile }) => {
  const similarity = _.get(detail, 'idFaceRecognitionResult.response.Similarity', 0)
  const similarityRoundVal = Math.round(similarity)
  const haveFRImageResult = hasFaceRecognitionImageFile && hasFaceImageFile

  return (
    <Container>
      <DetailContainer>
        <SubHeadingModified>ความตรงกันของใบหน้า</SubHeadingModified>
        <ImageContainer>
          {haveFRImageResult ? (
            <FaceComparisonResult similarity={similarityRoundVal} imageLeft={imageLeft} imageRight={imageRight} />
          ) : (
            <div style={{ textAlign: 'center' }}>{getIcon('rmsFaceNull')}</div>
          )}
        </ImageContainer>
        {haveFRImageResult && similarityRoundVal < 90 ? (
          <ResultContainer>
            <b>
              ผลการเปรียบเทียบใบหน้าไม่ผ่าน
              <br />
              กรุณาเขียนคำชี้แจง
            </b>
          </ResultContainer>
        ) : (
          <ResultContainer className="text-primary">
            <b>ผลการเปรียบเทียบใบหน้า</b>
            <SimilarityContainer>
              {haveFRImageResult && (
                <span>
                  <b style={{ fontSize: '50px' }}>{similarityRoundVal}</b>%
                </span>
              )}
            </SimilarityContainer>
            {haveFRImageResult && (
              <span>
                สถานะ : <b>ผ่านการเปรียบเทียบใบหน้า</b>
              </span>
            )}
          </ResultContainer>
        )}
      </DetailContainer>
    </Container>
  )
}

export const ELifeInsuranceDeclarationForm = ({ detail, doc, hasConfirmationLetterFile }) => {
  const isShowDoc = _.get(detail, 'insurancePolicyAgreementResult.response.confirmationAccepted', false) ?? false
  return (
    <Container>
      <DetailContainer>
        <SubHeadingModified>แบบแสดงความประสงค์ฯ โดยวิธีการทางอิเล็กทรอนิกส์</SubHeadingModified>
        {isShowDoc && hasConfirmationLetterFile ? (
          <div style={{ textAlign: 'center' }}>{getIcon('rmsConfirmLetterSuccess')}</div>
        ) : (
          <div style={{ textAlign: 'center' }}>{getIcon('rmsConfirmLetterNull')}</div>
        )}
      </DetailContainer>
    </Container>
  )
}

const getDOPAResultIcon = (verified, dopaRequestFailed) => {
  if (verified === null && dopaRequestFailed === null) {
    return 'citizenIdFront'
  }

  if (verified && !dopaRequestFailed) {
    return 'success'
  }

  if (!verified && !dopaRequestFailed) {
    return 'error'
  }

  if (dopaRequestFailed) {
    return 'warning'
  }
}

export const DetailDopa = ({ detail }) => {
  const dopaMap = {
    icon: {
      success: 'ekycDopaSuccess',
      error: 'ekycDopaError',
      warning: 'ekycDopaWarning',
      citizenIdFront: 'citizenIdFront',
    },
    reason: {
      success: 'ยืนยันตัวตนกับกรมการปกครอง (DOPA) สำเร็จ DOPA Verification successful',
      error:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elite, sed diam nonumy eirmod tempor invidunt ut labore et',
      warning: 'api reason',
    },
  }
  return (
    <Container>
      <div>
        {detail?.dopaResult
          ? getIcon(
              dopaMap.icon[getDOPAResultIcon(detail?.dopaResult?.verified, detail?.dopaResult?.dopaRequestFailed)]
            )
          : getIcon('citizenIdFront')}
      </div>
      <DetailContainer>
        <SubHeadingModified>บัตรประชาชนตรวจสอบเรียบร้อย</SubHeadingModified>
        <ResultContainerAlignLeft>
          {detail?.dopaResult?.message ? (
            <p>{detail?.dopaResult?.message}</p>
          ) : (
            <p>
              ยืนยันตัวตนกับกรมการปกครอง (DOPA) สำเร็จ <br />
              DOPA Verification successful
            </p>
          )}
        </ResultContainerAlignLeft>
      </DetailContainer>
    </Container>
  )
}

const mapStateToProps = (state, props) => {
  const app = getCurrentApp(state)
  const frontIdCardImage = _.get(state, `ui.setFrontIdCardImage.${props.insuredOrPayer}.frontIdCardImage`, null)
  const frontPassportImage = _.get(state, `ui.setFrontPassportImage.${props.insuredOrPayer}.frontPassportImage`, null)
  const faceRecognitionImage = _.get(
    state,
    `ui.setFaceRecognitionImage.${props.insuredOrPayer}.faceRecognitionImage`,
    null
  )
  const faceImage = _.get(state, `ui.setFaceImage.${props.insuredOrPayer}.faceImage`, null)
  const laserCode = _.get(state, `ui.setBackIdCardLaserCode.${props.insuredOrPayer}.laserCode`, '-')
  const isSkipped = _.get(app, `ekycInfo.${props.insuredOrPayer}.skipped`, false)

  return { frontPassportImage, frontIdCardImage, faceRecognitionImage, faceImage, laserCode, isSkipped }
}

export const _EkycDetail = ({
  detail,
  isShowDetail,
  setShowEkycDetail,
  frontPassportImage,
  frontIdCardImage,
  faceRecognitionImage,
  faceImage,
  laserCode,
  selectedRemoteSelling,
  foreigner,
  isForeignerWithoutPassport,
  isSkipped,
  isNeedConfirmationLetter,
  hasConfirmationLetterFile,
  hasFaceRecognitionImageFile,
  hasFaceImageFile,
}) => {
  const preparedDetail = prepareEkycDetailResult(detail)
  if (document.body.classList.contains('modal-open')) {
    document.body.classList.remove('modal-open')
  }

  return (
    <div>
      {isShowDetail ? (
        <div>
          {/*For F2F TH*/}
          {!foreigner && !selectedRemoteSelling && (
            <DetailFrontCitizenId detail={preparedDetail} frontIdCardImage={frontIdCardImage} />
          )}
          {!foreigner && !selectedRemoteSelling && (
            <DetailBackCitizenId detail={preparedDetail} laserCode={laserCode} />
          )}
          {!foreigner && !selectedRemoteSelling && <DetailDopa detail={preparedDetail} />}
          {/*For RMS TH*/}
          {!foreigner && selectedRemoteSelling && (
            <DetailFrontCitizenId detail={preparedDetail} frontIdCardImage={frontIdCardImage} />
          )}
          {!foreigner && selectedRemoteSelling && <DetailBackCitizenId detail={preparedDetail} laserCode={laserCode} />}
          {!foreigner && selectedRemoteSelling && <DetailDopa detail={preparedDetail} />}
          {!foreigner && selectedRemoteSelling && (
            <ResultFR
              detail={preparedDetail}
              imageLeft={faceImage}
              imageRight={faceRecognitionImage}
              hasFaceRecognitionImageFile={hasFaceRecognitionImageFile}
              hasFaceImageFile={hasFaceImageFile}
            />
          )}
          {!foreigner && selectedRemoteSelling && isNeedConfirmationLetter && (
            <ELifeInsuranceDeclarationForm
              detail={preparedDetail}
              doc={frontIdCardImage}
              hasConfirmationLetterFile={hasConfirmationLetterFile}
            />
          )}
          {/*For RMS None TH*/}
          {foreigner && selectedRemoteSelling && !isForeignerWithoutPassport && (
            <DetailPassport detail={preparedDetail} frontPassportImage={frontPassportImage} />
          )}
          {foreigner && selectedRemoteSelling && !isForeignerWithoutPassport && (
            <ResultFR
              detail={preparedDetail}
              imageLeft={faceImage}
              imageRight={faceRecognitionImage}
              hasFaceRecognitionImageFile={hasFaceRecognitionImageFile}
              hasFaceImageFile={hasFaceImageFile}
            />
          )}
          {foreigner && selectedRemoteSelling && !isForeignerWithoutPassport && isNeedConfirmationLetter && (
            <ELifeInsuranceDeclarationForm
              detail={preparedDetail}
              doc={frontIdCardImage}
              hasConfirmationLetterFile={hasConfirmationLetterFile}
            />
          )}
          <Footer>
            <Button
              outline
              icon="arrowUp"
              onClick={() => {
                setShowEkycDetail()
              }}
            >
              แสดงข้อมูล
            </Button>
          </Footer>
        </div>
      ) : null}
    </div>
  )
}

export default connect(mapStateToProps, null)(_EkycDetail)
